import actionCreatorFactory from 'typescript-fsa';

import { UserApps } from '@topconagriculture/frontend-utils';
import { User } from '@topconagriculture/profiling';

import reduxConfig from '../config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/user');

export const getApps = actionCreator.async<{}, UserApps>('GET_APPS');
export const getUserById = actionCreator.async<string, User>('GET_USER_BY_ID');
